<div class="position-relative tree-dropdown-radio">
  <mat-form-field class="form-group" [class.mat-form-field-invalid]="!selectedRecords.length && isSubmitted"
    (click)="clickout(null)" [class.loading-field]="recordsLoading">
    <mat-label>{{ 'complaints.complaintCategory' | translate }}</mat-label>
    <input class="field_chips" autocomplete="off" matInput [matChipInputFor]="chipRecordsList">
    <mat-chip-grid #chipRecordsList [required]="required">
      <mat-chip *ngFor="let node of selectedRecordsTree; index as i;">
        {{node.name}}
        <ng-container *ngIf="selectedRecordsTree.length != (i + 1)">
          <svg xmlns="http://www.w3.org/2000/svg" width="5" height="8" viewBox="0 0 5 8">
            <path id="arrow-down" d="M-2.313-6.729.75-3.627l3.063-3.1.937.949-4,4.051-4-4.051Z"
              transform="translate(-1.729 3.25) rotate(90)" fill="#6f95ac" />
          </svg>
        </ng-container>

      </mat-chip>
    </mat-chip-grid>
    <mat-icon matSuffix>{{showRecordsTree ? 'expand_less' : 'expand_more'}}</mat-icon>
    <p class="has-error" *ngIf="required &&!selectedRecords.length && isSubmitted">
      {{ 'forms.Required' | translate }}
    </p>
  </mat-form-field>
  <ng-container *ngIf="recordsTree.length && !isDisabled">
    <div class="tree-dropdown-inner" [hidden]="!showRecordsTree">
      <input class="search_field" placeholder="Search..." #searchInput [formControl]="searchCtrl" autocomplete="off"
        [matChipInputFor]="chipRecordsList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur" (keyup)="filterTree(searchInput.value,true)">
      <app-tree-radio [data]="recordsTree" [searchText]="searchInput.value"
        (selectedItem)="updateSelectedRecords($event)" [isSubmitted]="isSubmitted" [isRequired]="true"
        (selectedTree)="selectedRecordsTree = $event" [selectedInput]='detailsSelectedRecords'></app-tree-radio>
    </div>
  </ng-container>

</div>